$(document).ready(function () {
    //alert('custom');

    if($(".hideaftertimeout").length) {
        setTimeout(function(){
            $(".hideaftertimeout").fadeOut('fast');
        }, 3000);
    }

    $(".material_popup").hide();

    if (window.innerWidth > 767) {
        $('.open_bar').on('click', function () {
            $('.sidebar').toggleClass('active');
            $('.content_body').toggleClass('active');
        });
    }

    $('.mobile-nav-toggle').on('click', function () {
        $('.sidebar').toggleClass('active');
        $('.content_body').toggleClass('active');
    });

    $('#click_table1').on('click', function () {
        $('#open_table1').toggleClass('active');
        $('#click_table1').toggleClass('active');
    });

    $('#click_submenu1').on('click', function () {
        $('#table_popup').toggleClass('active');
        $('#click_submenu1').toggleClass('active');
    });

    $('#click_sub_submenu1').on('click', function () {
        $('#table_sub_popup').toggleClass('active');
        $('#click_sub_submenu1').toggleClass('active');
    });

    $(".close_mt_popup").click(function () {
        $(".material_popup").hide();
    });

    $('#pt_open1').on('click', function () {
        $('#pt_open1').toggleClass('active');
        $('.pt_inner_table').toggleClass('active');
    });

    $(".toggle-filter").click(function () {
        $(".filter-popup").show();
    });

    $(".toggle-date").click(function () {
        $(".date-popup").show();
    });

    $('#cd_dropdown1').on('click', function () {
        $('#cd_dropdown1').toggleClass('active');
    });

    $('#cd_dropdown2').on('click', function () {
        $('#cd_dropdown2').toggleClass('active');
    });

    $('#cd_dropdown3').on('click', function () {
        $('#cd_dropdown3').toggleClass('active');
    });

    $('#cd_dropdown4').on('click', function () {
        $('#cd_dropdown4').toggleClass('active');
    });

    $('#cd_dropdown5').on('click', function () {
        $('#cd_dropdown5').toggleClass('active');
    });

    $("#popup2").click(function () {
        $(".none_dp").hide();
    });

    $(".cl_pp1").click(function () {
        $(".popup_moodboard").hide();
    });

    $(".cl_pp1").click(function () {
        $(".popup_moodboard_img").hide();
    });

    /*
    $('.admin_img').on('click', function () {
        $('.account_dropdown').toggleClass('active');
    });
    */

    if ($('.less_than_four_images').length) {
        $('.less_than_four_images .images_slider').owlCarousel({
            loop: false,
            margin: 15,
            autoplay: true,
            dots: false,
            nav: false,
            startPosition: 1,
            responsive: {
                0: {
                    items: 1,
                    //stagePadding: 40,
                },
                768: {
                    items: 3,
                    //stagePadding: 40,
                },
                1280: {
                    items: 4,
                    //stagePadding: 150,
                }
            }
        });
    }
    

    if ($('.job-image-slider').length) {
        $('.job-image-slider').owlCarousel({
            loop: true,
            margin: 15,
            autoplay: true,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 2
                },
                768: {
                    items: 4
                },
                1280: {
                    items: 8
                }
            }
        });
    }

    if ($('.more_than_four_images').length) {
        $('.more_than_four_images .images_slider').owlCarousel({
            loop: false,
            margin: 15,
            autoplay: true,
            dots: false,
            nav: false,
            startPosition: 1,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 40,
                },
                768: {
                    items: 3,
                    stagePadding: 40,
                },
                1280: {
                    items: 4,
                    stagePadding: 150,
                }
            }
        });
    }

    if ($('.date_slider').length) {
        $('.date_slider').owlCarousel({
            loop: true,
            margin: 10,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 2
                },
                768: {
                    items: 4
                },
                1280: {
                    items: 7
                }
            }
        });
    }

    if ($('.msg_slider').length) {
        $('.msg_slider').owlCarousel({
            loop: true,
            margin: 0,
            autoplay: true,
			autoplayHoverPause:true,
            dots: true,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                },
                1280: {
                    items: 1
                }
            }
        });
    }

    if ($('.guide-slider').length) {
        var guideOwl = $('.guide-slider').owlCarousel({
            loop: true,
            margin: 0,
            dots: false,
            animateOut: 'fadeOut',
            nav: true,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                },
                1280: {
                    items: 1
                }
            }
        });

        $("#menu-dashboard").addClass('guide-slide-active dashboard');

        guideOwl.on('changed.owl.carousel',function(property){
            $(".tour-menu-item").removeClass('guide-slide-active');

            var current = property.item.index;
            var slide = $(property.target).find(".owl-item").eq(current).find(".item").data('slide');

            $("#menu-" + slide).addClass('guide-slide-active ' + slide);

            if(slide == 'dashboard') {
                $(".tour-menu-item").removeClass('guide-slide-active');
                $(".tour-menu-item").removeClass('dashboard');
                $(".all-guide-tour").hide();
            }
        });
    }

    $(".skip-tour").click(function () {
        $(".tour-menu-item").removeClass('guide-slide-active');
        $(".all-guide-tour").hide();
    });
    

    if ($('.guide-slider').length) {
        $('.guide-slider').owlCarousel({
            loop: true,
            margin: 0,
            dots: false,
            animateOut: 'fadeOut',
            nav: true,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                },
                1280: {
                    items: 1
                }
            }
        });
    }

    if ($('.banner-render-slider').length) {
        $('.banner-render-slider').owlCarousel({
            autoplay: true,
            loop: true,
            margin: 12,
            dots: false,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 1
                },
                1024: {
                    items: 1
                }
            }
        });
    }

    $(".skip-tour").click(function () {
        $(".all-guide-tour").hide();
    });

    $('.order-items-list').on('click', '.click_fields', function () {
        $(this).next('.cm-dropdown-content').toggleClass('active');
    });

    $('.create-order-form').on('click', '.click_fields', function () {
        $(this).next('.cm-dropdown-content').toggleClass('active');
    });

    $('.click_fields').on('click', function () {
        $('.customer-measurement-ul').toggleClass('active');
    });

    $(document).on('click', '.click_heading', function () {
        $(this).closest('.generator_details').find('.generator_add_img').toggleClass('active');
        $(this).closest('.generator_details').find('.right_float').toggleClass('rotate');
    });

    $(".plan-tabs a[data-toggle='tab']").on("shown.bs.tab", function () {
        $("html, body").stop().animate({ scrollTop: $(".plan-tabs").offset().top - 70 }, 180);
    });

    if ($('.testimonial-slide').length) {
        $('.testimonial-slide').owlCarousel({
            loop: true,
            margin: 12,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            }
        });
    }
});